export default "<div class=\"bg\"></div>\r\n"